import { PaymentConditionOption } from './payment-condition-option';

export class PaymentMethodOption {

  name: string;
  identifier: string;
  paymentConditionOptions: Array<PaymentConditionOption>;
  maxInstallment: number; // TODO - Pode remover esse campo? O que esta vindo do backend eh maxInstallments
  maxInstallments: number;
  maxInstallmentValue: number;
  maxInstallmentIdentifier: string;


  constructor(paymentMethodOptionData: any) {
    this.identifier = paymentMethodOptionData.identifier;
    this.paymentConditionOptions = paymentMethodOptionData.paymentConditionOptions
      ? paymentMethodOptionData.paymentConditionOptions.map(pcoData => new PaymentConditionOption(pcoData)) : [];
    this.name = paymentMethodOptionData.name;
    this.maxInstallment = paymentMethodOptionData.maxInstallment;
    this.maxInstallments = paymentMethodOptionData.maxInstallments;
    this.maxInstallmentValue = paymentMethodOptionData.maxInstallmentValue;
    this.maxInstallmentIdentifier = paymentMethodOptionData.maxInstallmentIdentifier;
  }

}
